import React, { createContext, useContext, useState, useCallback } from "react";
import { messages } from "./messages";

const STORAGE_KEY = "chatbot_lang";
const SUPPORTED = ["ko", "zh"];
const DEFAULT_LANG = "ko";

function readInitialLang() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return SUPPORTED.includes(saved) ? saved : DEFAULT_LANG;
  } catch {
    return DEFAULT_LANG;
  }
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(readInitialLang);

  const setLang = useCallback((next) => {
    const normalized = SUPPORTED.includes(next) ? next : DEFAULT_LANG;
    setLangState(normalized);
    try {
      window.localStorage.setItem(STORAGE_KEY, normalized);
    } catch {
      /* localStorage 불가(사생활 모드 등) 시 무시 */
    }
  }, []);

  const t = useCallback(
    (key) => {
      const dict = messages[lang] || messages[DEFAULT_LANG];
      return dict[key] ?? messages[DEFAULT_LANG][key] ?? key;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return ctx;
}
